module.exports = __webpack_public_path__ + "static/media/3d-chess.a5c1d3d7.jpg";